import { ActionTree, ActionContext } from 'vuex'
import { IRootState, FeatureFlagsState } from '@/@types'
import {
  getAllDarklyFlags,
  createDarklyClient,
  closeDarklyClient,
  errorHandler,
  switchDarklyContextToAnonymous,
  onDarklyFeatureFlagChange,
} from '@/utils'

import * as defaultState from './state'

const updateFlags = async (context: ActionContext<FeatureFlagsState, IRootState>) => {
  const newFlags = await getAllDarklyFlags()
  context.commit('FEATURE_FLAGS_UPDATED', { ...newFlags })
}

const cleanFlagsStore = (context: ActionContext<FeatureFlagsState, IRootState>) => {
  context.commit('FEATURE_FLAGS_UPDATED', defaultState)
}

const actions: ActionTree<FeatureFlagsState, IRootState> = {
  updateFeatureFlags: async (context: ActionContext<FeatureFlagsState, IRootState>) => {
    try {
      await updateFlags(context)
    } catch (error) {
      const message = errorHandler(error)
      context.dispatch('app/setError', message, { root: true })
    }
  },
  initializeDarkly: async (context: ActionContext<FeatureFlagsState, IRootState>) => {
    try {
      await createDarklyClient()
      await context.dispatch('updateFeatureFlags')
      // add callback for each Launch Darkly feature flag
      Object.keys(context.state).map((flag: string) => {
        onDarklyFeatureFlagChange(flag, () => {
          updateFlags(context)
        })
      })
    } catch (error) {
      cleanFlagsStore(context)
    }
  },
  closeDarkly: async (context: ActionContext<FeatureFlagsState, IRootState>) => {
    try {
      await closeDarklyClient()
    } finally {
      cleanFlagsStore(context)
    }
  },
  switchDarklyContextToAnonymous: async (context: ActionContext<FeatureFlagsState, IRootState>) => {
    try {
      await switchDarklyContextToAnonymous()
    } catch (error) {
      cleanFlagsStore(context)
    }
  },
}

export default actions
